import { Component, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtilsService } from 'src/app/common';
import { TooltipModule } from 'primeng/tooltip';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'gig-website-info',
  standalone: true,
  imports: [CommonModule, TooltipModule, TranslateModule],
  templateUrl: './website-info.component.html',
  styleUrls: ['./website-info.component.scss']
})
export class WebsiteInfoComponent implements OnInit {

  @Input() data: any;
  @Input() type: string;

  constructor( private utils: UtilsService) { }

  ngOnInit(): void {
    this.utils.logger.info("organic", this.data);
  }

    objectKeys(obj: any): string[] {
        return Object.keys(obj);
    }
    formatHeader(key: string): string {
        const formattedKey = key
            .replace(/([a-z])([A-Z])/g, '$1 $2')
            .replace(/(\d+)(to)(\d+)/g, '$1 to $3')
            .replace(/(\d+)/g, ' $1')
            .replace(/^etv$/i, 'ETV')
            .replace(/^newRankings$/i, 'New Rankings')
            .replace(/^lostRankings$/i, 'Lost Rankings')
            .replace(/^upRankings$/i, 'Up Rankings')
            .replace(/^downRankings$/i, 'Down Rankings');
        return formattedKey.charAt(0).toUpperCase() + formattedKey.slice(1);
    }

}
